import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import { PermeaCalculationLinesApi, PermeaTagsApi } from "@socotec.io/atm-back-sdk";
import { listAllPages } from "@/api/utils/sdk";

const api = new PermeaCalculationLinesApi(atmBackConfiguration);
const permeaTagsApi = new PermeaTagsApi(atmBackConfiguration);

export const fetchPermeaTag = async () => {
  return await permeaTagsApi.list();
};

export const fetchPermeaCalculationLine = async ({ zone } = {}) => {
  return listAllPages((page) => api.list({ zone, page }));
};

export const createPermeaCalculationLine = async (permeaCalculationLineData) => {
  return await api.create({ permeaCalculationLineRequest: permeaCalculationLineData });
};

export const destroyPermeaCalculationLine = async (uuid) => {
  await api.destroy({ uuid });
};

export const updatePermeaCalculationLine = async (permeaCalculationLineData) => {
  const { uuid, ...rest } = permeaCalculationLineData;
  return await api.partialUpdate({
    uuid,
    patchedPermeaCalculationLineRequest: rest,
  });
};
